import React from 'react';
import {FieldViewProps} from "../../../render/view";
import GDProjectName from "../../../../gd-ui/project-name/project-name";
import Meeting from "../../../../model2/meeting/meeting";

export default function FieldMeeting_View(props:FieldViewProps) {

    const meeting = _.get(props.model, props.field.fieldId, null) as Meeting

    if (!meeting) return null

    const classes = Classes("flex-row-left-center ", "", props.className, {
        // 'invalid-value': !props.field.isValueValid(value)
    })

    return (
        <div className={classes}>
            <div className="i5-meeting ui5-ico-14 m-r-5"/>
            <span className="ui5-txt-default txt-truncate no-wrap">{meeting.name}</span>

            {meeting.projectId &&
                <GDProjectName className="m-l-10"
                               projectId={meeting.projectId}
                               type="ui5-prop"
                               hintFullPath={true} />
            }


        </div>
    );
}
